module.exports = __webpack_public_path__ + "img/chatbot-cat.8a912fae.svg";